<template>
	<div class="orderDetails" :class="{ active: areDetailsShown }">
		<div class="orderDetails__container">
			<div class="orderDetails__side orderDetails__side--left">
				<OrderInfo :orderData="orderData"></OrderInfo>
			</div>
			<div class="orderDetails__side orderDetails__side--right">
				<h3 class="orderDetails__title" v-if="itemtableData">
					ORDER ITEM(S) LIST (<span>{{ itemtableData.length }}</span>)
				</h3>
				<div class="orderDetails__items-wrap">
					<ItemsDetails v-for="(item, index) in itemtableData" :key="item.itemserial" :item-detail="item" :idx="index" ></ItemsDetails>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Vue from "vue";
import OrderInfo from "@/components/listOrders/OrderInfo.vue";
import ItemsDetails from "@/components/listOrders/ItemsDetails.vue";

export default Vue.extend({
	name: "OrderDetails",
	components: {
		OrderInfo,
		ItemsDetails
	},
	props: {
		areDetailsShown: {
			type: Boolean
		},
		orderData: {
			type: Object
		},
		itemtableData: {
			type: Array
		}
	}
});
</script>

<style lang="scss" scoped>
.orderDetails {
	background-color: $color1;
	overflow: hidden;
	height: 0;

	&.active {
		height: 780px;
	}

	&__container {
		display: flex;

		padding: 20px;
	}

	&__title {
		text-align: center;
		font-weight: bold;
		line-height: 27px;
		font-size: 20px;
		margin-bottom: 10px;
	}

	&__side--left {
		margin-right: 20px;
	}

	&__side--right {
		margin-left: 20px;
		flex-grow: 1;

		border-radius: 10px;
		border: 1px solid rgba($border-color, 0.2);
		padding: 20px 15px 5px 20px;
		box-shadow: 1px 1px 1px $border-color;
	}

	&__items-wrap {
		overflow-y: scroll;
		height: 680px;
	}
}
</style>